import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Checkmark from './icon-checkmark.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Checkmark {...validProps} />;
}
SvgComponent.iconName = 'checkmark';

/**
 * @deprecated This is a legacy icon
 */
export const CheckmarkIcon = svgIconWrapper(SvgComponent);
